/**
 * The one call to action, wherever it appears.
 *
 * Five places used to call `useWaitlist().open()` — the hero, the final CTA,
 * the pricing section, the header and the footer. Each would have needed the
 * same edit on launch day, and would need it again the day Android lands. So
 * the decision lives here instead: this asks whether the app is downloadable
 * and renders a store link, or the waitlist opener if it is not.
 *
 * It takes children rather than a label because the hero puts an arrow inside
 * its button and the sections word the thing differently.
 *
 * `source` is kept even while the list is parked: it is what tells you which
 * button somebody pressed, and it costs nothing to keep threading it through.
 */
import type { ReactNode } from 'react';

import { Button } from './Button';
import { useWaitlist } from './WaitlistProvider';
import { PRODUCT, isReleased } from '../lib/constants';

interface Props {
  source: string;
  children: ReactNode;
  variant?: 'primary' | 'outline' | 'onInk';
  size?: 'md' | 'lg';
  block?: boolean;
}

export function GetItButton({ source, children, variant, size, block }: Props) {
  const { open } = useWaitlist();

  if (isReleased && PRODUCT.store.ios) {
    return (
      <Button href={PRODUCT.store.ios} external variant={variant} size={size} block={block}>
        {children}
      </Button>
    );
  }

  return (
    <Button onClick={() => open(source)} variant={variant} size={size} block={block}>
      {children}
    </Button>
  );
}
